import {
  GET_GAM_SIGNALS,
  TOGGLE_GAM_SIGNAL,
  GET_NIELSEN_CONFIG,
} from "./gamSignal.type";

const initialState = {
  groups: [],
  total: 0,
  enabledCount: 0,
  nielsen: null,
};

const gamSignalReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GAM_SIGNALS:
      return {
        ...state,
        groups: action.payload.groups,
        total: action.payload.total,
        enabledCount: action.payload.enabledCount,
      };

    case TOGGLE_GAM_SIGNAL: {
      const { key, enabled } = action.payload;
      let enabledCount = state.enabledCount;
      const groups = state.groups.map((group) => ({
        ...group,
        signals: group.signals.map((s) => {
          if (s.key !== key || s.enabled === enabled) return s;
          enabledCount += enabled ? 1 : -1;
          return { ...s, enabled };
        }),
      }));
      return { ...state, groups, enabledCount };
    }

    case GET_NIELSEN_CONFIG:
      return { ...state, nielsen: action.payload };

    default:
      return state;
  }
};

export default gamSignalReducer;
